import { isTruncateDesignationsEnabled } from "~/utils/features";

const MAX_CHARS = 11;
export const getDesignationAbbreviation =
  (maxChars = MAX_CHARS) =>
  (designation: string) => {
    if (!designation) {
      return "";
    }

    if (!isTruncateDesignationsEnabled()) {
      return designation;
    }

    if (designation.length <= maxChars) {
      return designation;
    }

    // Temporary logic for SCHAEFF-18539 - Just cut the designation if it's too long for kit/universal.
    // These designations will contain "+" for sure
    if (designation.includes("+")) {
      return designation.substring(0, maxChars) + "...";
    }

    const parts = designation.split("-");

    const maxCharsAbbr = maxChars + 3;

    // Custom manual logic...
    if (parts.length === 1) {
      return designation.substring(0, maxChars) + "...";
    }
    if (parts.length <= 3) {
      let candidate = `${parts[0]}-...-${last(parts)}`;
      if (candidate.length <= maxCharsAbbr) {
        return candidate;
      }
      const excess = candidate.length - maxCharsAbbr;
      if (excess < parts[0].length) {
        candidate = `${parts[0].slice(0, parts[0].length - excess + 1)}...-${last(parts)}`;
      } else {
        candidate = designation.substring(0, maxChars) + "...";
      }
      return candidate;
    }

    return `${parts[0]}-${parts[1]}...-${last(parts)}`;
  };
const last = <T extends any>(arr: T[]): T => arr[arr.length - 1];
